export const updateHistoryStackBeforeSelect = (state) => {
  const { boardId, paths, selectionRectPathKeys, historyStack, setHistoryStack } = state

  // stack 배열 길이 강제 조정
  if (historyStack[boardId].stack.length !== historyStack[boardId].pointer + 1)
    historyStack[boardId].stack.length = historyStack[boardId].pointer + 1

  setHistoryStack((prev) => {
    const updatedStack = [
      ...prev[boardId].stack,
      {
        type: 'select',
        pathKeys: [...selectionRectPathKeys],
        beforePathData: structuredClone(paths),
        afterPathData: {},
      },
    ]
    const updatedStackPointer = prev[boardId].pointer + 1

    return {
      ...prev,
      [boardId]: {
        stack: updatedStack,
        pointer: updatedStackPointer,
      },
    }
  })
}

export const updateHistoryStackAfterSelect = (state) => {
  const { boardId, paths, setHistoryStack } = state

  setHistoryStack((prev) => {
    const updatedStack = [...prev[boardId].stack]
    updatedStack[prev[boardId].pointer].afterPathData = structuredClone(paths)

    return {
      ...prev,
      [boardId]: {
        ...prev[boardId],
        stack: updatedStack,
      },
    }
  })
}

export const updateHistoryStackAfterDraw = (state) => {
  const { boardId, currentPath, currentPathId, historyStack, setHistoryStack } = state

  // stack 배열 길이 강제 조정
  historyStack[boardId].stack.length = historyStack[boardId].pointer + 1

  const updatedStack = [
    ...historyStack[boardId].stack,
    {
      type: 'draw',
      pathKeys: currentPathId.current,
      pathData: structuredClone(currentPath.current),
    },
  ]
  const updatedStackPointer = historyStack[boardId].pointer + 1

  setHistoryStack((prev) => {
    return {
      ...prev,
      [boardId]: {
        stack: updatedStack,
        pointer: updatedStackPointer,
      },
    }
  })
}

export const updateHistoryStackAfterErase = (state) => {
  const { boardId, eraseStack, historyStack, setHistoryStack } = state

  // stack 배열 길이 강제 조정
  if (historyStack[boardId].stack.length !== historyStack[boardId].pointer + 1)
    historyStack[boardId].stack.length = historyStack[boardId].pointer + 1

  setHistoryStack((prev) => {
    const updatedStack = [...prev[boardId].stack, eraseStack]
    const updatedStackPointer = prev[boardId].pointer + 1

    return {
      ...prev,
      [boardId]: {
        stack: updatedStack,
        pointer: updatedStackPointer,
      },
    }
  })
}

// toolbar - Image
export const updateHistoryStackImage = (state) => {
  const { boardId, id, newImage, historyStack, setHistoryStack } = state

  // stack 배열 길이 강제 조정
  if (historyStack[boardId].stack.length !== historyStack[boardId].pointer + 1)
    historyStack[boardId].stack.length = historyStack[boardId].pointer + 1

  const updatedStack = [
    ...historyStack[boardId].stack,
    {
      type: 'image',
      pathKeys: id,
      pathData: structuredClone(newImage),
    },
  ]
  const updatedStackPointer = historyStack[boardId].pointer + 1

  setHistoryStack((prev) => {
    return {
      ...prev,
      [boardId]: {
        stack: updatedStack,
        pointer: updatedStackPointer,
      },
    }
  })
}

// bottom panel - Reset
export const updateHistoryStackReset = (state) => {
  const { boardId, eraseStack, setHistoryStack } = state

  setHistoryStack((prev) => {
    const updatedStack = [...prev[boardId].stack, eraseStack]
    const updatedStackPointer = prev[boardId].pointer + 1

    return {
      ...prev,
      [boardId]: {
        stack: updatedStack,
        pointer: updatedStackPointer,
      },
    }
  })
}
